import {
  STATE_WELCOME,
  STATE_WORLD_MAP,
  STATE_LOCATION_LOADER,
  STATE_ANIM_STORY_LOCATION,
  STATE_MINIGAME_LOADER,
  MINIGAME_CHASE,
  MINIGAME_FOOD,
  STATE_SUITCASE,
  STATE_HOWTOPLAY,
  STATE_MINIGAME_CHASE,
  STATE_MINIGAME_FOOD,
  STATE_ANIM_STORY_INTRO,
  STATE_ANIM_STORY_END,
} from '../constants/AppConstants';
import PlayerController from './PlayerController';
import CheatController from './CheatController';
import ShortcutController from './ShortcutController';

export default class GameController {
  constructor(game) {
    this.game = game;

    this.player = new PlayerController();
    this.player.loadSavedData();
    if (__SHORTCUTS_ENABLED__ || window.location.href.includes('dev-scoobytravel')) {
      this.cheats = new CheatController(this.game);
      this.shortcutController = new ShortcutController(this.game);
    }
  }

  triggerWelcome() {
    //this.game.sounds.stopBackgroundMusic();
    this.player.clearCurrentState();
    this.game.state.start(STATE_WELCOME, true, false);
  }

  triggerWorldState() {
    this.game.state.start(STATE_WORLD_MAP, true, false);
  }

  triggerPlayerSuitcase(returnState, locationid) {
    this.game.state.start(STATE_SUITCASE, true, false, { returnState, locationid });
  }

  triggerHowToPlay() {
    this.game.state.start(STATE_HOWTOPLAY, true, false);
  }

  triggerStoryIntro() {
    this.game.state.start(STATE_ANIM_STORY_INTRO, true, false, {
      watched: this.player.getStoryIntroSeen(),
    });
    this.player.setStoryIntroSeen(true);
  }

  triggerStoryLocationLeave(locationid) {
    this.game.state.start(STATE_ANIM_STORY_LOCATION, true, false, {
      watched: this.player.getStoryOutroSeen(locationid),
      locationid: locationid,
    });
    this.player.setLocationOutroSeen(locationid);
  }

  triggerStoryOutro() {
    this.game.state.start(STATE_ANIM_STORY_END, true, false, {
      watched: this.player.getStoryOutroSeen(),
    });
    this.player.setStoryOutroSeen(true);
  }

  /*
  ================================================
    LOCATION
  ================================================
  */

  triggerCurrentPlayerLocation() {
    const currentLocation = this.player.getCurrentLocation();
    if (currentLocation) {
      this.triggerLocation(this.player.getCurrentLocation());
    } else {
      console.warn('triggering location where player has none');
    }
  }

  triggerLocation(locationid) {
    this.player.setCurrentLocation(locationid);
    this.game.state.start(STATE_LOCATION_LOADER, true, false, { locationid });
  }

  triggerLocationExit(locationid) {
    if (this.player.getLocationOutroSeen(locationid) === false) {
      this.player.queueLocationSticker(locationid);
      this.player.setNextStoryLocation();
      if (this.player.getNextLocation()) {
        this.triggerStoryLocationLeave(locationid);
      } else {
        this.player.setLocationOutroSeen(locationid);
        this.triggerStoryOutro();
      }
    } else {
      this.player.queueLocationSticker(false);
      this.triggerWorldState();
    }
  }

  /*
  ================================================
    MINI GAMES
  ================================================
  */

  triggerMiniGameFood({ locationid, suitcaselaunched, cheatlaunched } = {}) {
    const currentLocation = locationid || this.player.getCurrentLocation();
    this.triggerMiniGame({
      state: STATE_MINIGAME_LOADER,
      suitcaselaunched,
      cheatlaunched,
      data: {
        minigameid: MINIGAME_FOOD,
        locationid: currentLocation,
      },
    });
  }
  triggerMiniGameChase({ locationid, suitcaselaunched, cheatlaunched } = {}) {
    const currentLocation = locationid || this.player.getCurrentLocation();
    this.triggerMiniGame({
      state: STATE_MINIGAME_LOADER,
      suitcaselaunched,
      cheatlaunched,
      data: {
        minigameid: MINIGAME_CHASE,
        locationid: currentLocation,
      },
    });
  }

  triggerMiniGame({ state, suitcaselaunched, cheatlaunched, data }) {
    this.cheatlaunched = cheatlaunched;
    this.suitcaselaunched = suitcaselaunched;
    this.game.state.start(state, true, false, data);
  }

  endMiniGame() {
    if (this.cheatlaunched) {
      this.triggerWelcome();
    } else if (this.suitcaselaunched) {
      this.triggerPlayerSuitcase();
    } else {
      this.triggerCurrentPlayerLocation();
    }
  }

  /*
  ================================================
    LOOK UPS
  ================================================
  */

  isPlayingMiniGame() {
    const currentState = this.game.state.getCurrentState().key;
    return currentState === STATE_MINIGAME_CHASE || currentState === STATE_MINIGAME_FOOD;
  }
}



// WEBPACK FOOTER //
// ./js/app/controller/GameController.js